/** Join note or solfege labels with hyphens: G-A-B, do-re-mi */
export function formatHyphenLine(items: string[]): string {
  return items.filter(Boolean).join('-');
}
